// extracted by mini-css-extract-plugin
export var closeButton = "_js-1";
export var closeX = "_js-3";
export var container = "_js-0";
export var image = "_js-2";